import {useIntl} from "react-intl";
import * as React from "react";
import FileAlt from "../../../../Elements/Icon/Icons/Safemate/outline/FileAlt";
import { Placeholder, StyledButtonMob } from './index';
import { DeviceHardwareEnum, isGx8 } from '../../../DeviceHardwareEnum';
import { LabelEnum } from '../../LabelEnum';
import Map from "../../../../Elements/Icon/Icons/settings/Map";
import {Capabilities} from "@Safemate/Settings/Store/types";

interface LogProps{
  noAccess?: boolean;
  isTracker: boolean;
  deviceId: number
  lastMsgIn: number;
}

const Log = ({ isTracker, lastMsgIn, deviceId, noAccess }: LogProps) => {

  if(!lastMsgIn || isTracker || noAccess) return <Placeholder/>;

  const { formatMessage } = useIntl();

  return(
    <StyledButtonMob
      title={formatMessage({id: LabelEnum.SHOW_LOG, defaultMessage: "Logg"})}
      onClick={(event) => {
        event.stopPropagation();
        location.hash = `txlog/${deviceId}`;
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') 
          location.hash = `txlog/${deviceId}`;
      }}
    >
      <FileAlt
        size="medium"
        inline
      />
    </StyledButtonMob>
  )
};

export default Log;
